import { RedirectFunction, Router } from '@angular/router';
import { AuthService } from '@meddata/core/services';
import { inject } from '@angular/core';

/**
 * A redirect function that determines the route based on the user's authentication status.
 * If the user is not logged in, they are redirected to the login page.
 * If the user is authenticated but navigates to a non-existent route, they are redirected to the not-found page.
 */
export const NotFoundRedirect: RedirectFunction = () => {
  const _authService: AuthService = inject(AuthService);
  const _router: Router = inject(Router);
  if (!_authService.isLoggedIn()) return _router.createUrlTree(['/login']);
  return _router.createUrlTree(['/not-found']);
};
